import { render, staticRenderFns } from "./DialogChangeTransferStatusCompanyAdmin.vue?vue&type=template&id=e2d735d2&"
import script from "./DialogChangeTransferStatusCompanyAdmin.vue?vue&type=script&lang=js&"
export * from "./DialogChangeTransferStatusCompanyAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DialogChangeTransferStatusCompanyAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2d735d2')) {
      api.createRecord('e2d735d2', component.options)
    } else {
      api.reload('e2d735d2', component.options)
    }
    module.hot.accept("./DialogChangeTransferStatusCompanyAdmin.vue?vue&type=template&id=e2d735d2&", function () {
      api.rerender('e2d735d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogChangeTransferStatusCompanyAdmin.vue"
export default component.exports